import {
  createElement,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ImgHTMLAttributes,
} from "react";

export type SproutImagePrimitiveProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  imageClassName?: string;
  priority?: boolean;
  src: string;
};

export type SproutLinkPrimitiveProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};

export type SproutPrimitiveRegistry = {
  Image: ComponentType<SproutImagePrimitiveProps>;
  Link: ComponentType<SproutLinkPrimitiveProps>;
};

export type SproutPrimitiveName = keyof SproutPrimitiveRegistry;

const Image = ({ imageClassName, priority: _priority, ...props }: SproutImagePrimitiveProps) =>
  createElement("img", {
    ...props,
    className: [props.className, imageClassName].filter(Boolean).join(" ") || undefined,
  });

const Link = ({ children, rel, target, ...props }: SproutLinkPrimitiveProps) =>
  createElement(
    "a",
    { ...props, rel: target === "_blank" && !rel ? "noopener noreferrer" : rel, target },
    children,
  );

const registry: SproutPrimitiveRegistry = { Image, Link };

export function registerComponent<K extends SproutPrimitiveName>(
  name: K,
  component: SproutPrimitiveRegistry[K],
) {
  registry[name] = component;
}

export function getComponent<K extends SproutPrimitiveName>(name: K): SproutPrimitiveRegistry[K] {
  return registry[name];
}
